import React, { Fragment, PureComponent } from 'react';
import { Container, Table } from 'reactstrap';
import FormatNumber from '../FormatNumber';
import './ComparisionSummary.css';

class ComparisionTable extends PureComponent {
  // static defaultProps = {
  //   summaryData: {},
  // };

  // eslint-disable-next-line class-methods-use-this
  generateSummaryRows(summaryData) {
    // eslint-disable-line class-methods-use-this
    if (!summaryData) {
      return null;
    }

    const {
      newSummary: {
        summary: { discount: newDiscount, roomDetails: newRoomDetails },
      },
      oldSummary: {
        summary: { discount: oldDiscount, roomDetails: oldRoomDetails },
      },
    } = summaryData;

    const oldRoomMap = new Map();
    const newRoomMap = new Map();

    oldRoomDetails.forEach((oldRoom) => {
      oldRoomMap.set(oldRoom.name, oldRoom);
    });

    newRoomDetails.forEach((newRoom) => {
      newRoomMap.set(newRoom.name, newRoom);
    });

    const subtotalMap = {
      woodwork: 0,
      accessories: 0,
      appliances: 0,
      services: 0,
      furniture: 0,
      roomsTotal: 0,
      woodworkDiff: 0,
      accessoriesDiff: 0,
      appliancesDiff: 0,
      servicesDiff: 0,
      furnitureDiff: 0,
      roomsTotalDiff: 0,
    };

    const summaryRows = newRoomDetails.map((newRoom) => {
      const oldRoom = oldRoomMap.get(newRoom.name) || {};
      const [
        wwDiff,
        accDiff,
        appDiff,
        hdsDiff,
        furnitureDiff,
        roomTotalDiff,
      ] = [
        newRoom.wwTotal - (oldRoom.wwTotal || 0),
        newRoom.accTotal - (oldRoom.accTotal || 0),
        newRoom.appTotal - (oldRoom.appTotal || 0),
        newRoom.hdsTotal - (oldRoom.hdsTotal || 0),
        newRoom.furniturePrice - (oldRoom.furniturePrice || 0),
        newRoom.roomTotal - (oldRoom.roomTotal || 0),
      ];

      subtotalMap.woodwork += newRoom.wwTotal;
      subtotalMap.accessories += newRoom.accTotal;
      subtotalMap.appliances += newRoom.appTotal;
      subtotalMap.services += newRoom.hdsTotal;
      subtotalMap.furniture += newRoom.furniturePrice;
      subtotalMap.roomsTotal += newRoom.roomTotal;

      subtotalMap.woodworkDiff += wwDiff;
      subtotalMap.accessoriesDiff += accDiff;
      subtotalMap.appliancesDiff += appDiff;
      subtotalMap.servicesDiff += hdsDiff;
      subtotalMap.furnitureDiff += furnitureDiff;
      subtotalMap.roomsTotalDiff += roomTotalDiff;

      return (
        <Fragment>
          <tr key={newRoom.name}>
            <td>{newRoom.roomType}</td>
            <td>{newRoom.name}</td>
            <td>
              {newRoom.wwTotal.toLocaleString('en-IN')}
              {' '}
              <FormatNumber number={wwDiff} />
            </td>
            <td>
              {newRoom.accTotal.toLocaleString('en-IN')}
              {' '}
              <FormatNumber number={accDiff} />
            </td>
            <td>
              {newRoom.appTotal.toLocaleString('en-IN')}
              {' '}
              <FormatNumber number={appDiff} />
            </td>
            <td>
              {newRoom.hdsTotal.toLocaleString('en-IN')}
              {' '}
              <FormatNumber number={hdsDiff} />
            </td>
            <td>
              {newRoom.furniturePrice.toLocaleString('en-IN')}
              {' '}
              <FormatNumber number={furnitureDiff} />
            </td>
            <td>
              {newRoom.roomTotal.toLocaleString('en-IN')}
              {' '}
              <FormatNumber number={roomTotalDiff} />
            </td>
          </tr>
        </Fragment>
      );
    });

    oldRoomDetails.forEach((oldRoom) => {
      if (!newRoomMap.get(oldRoom.name)) {
        // const oldRoom = oldRoomMap.get(oldRoom.name) || {};
        const newRoom = {}; // dummy variabe

        console.log(oldRoom);
        const [
          wwDiff,
          accDiff,
          appDiff,
          hdsDiff,
          furnitureDiff,
          roomTotalDiff,
        ] = [
          (newRoom.wwTotal || 0) - (oldRoom.wwTotal || 0),
          (newRoom.accTotal || 0) - (oldRoom.accTotal || 0),
          (newRoom.appTotal || 0) - (oldRoom.appTotal || 0),
          (newRoom.hdsTotal || 0) - (oldRoom.hdsTotal || 0),
          (newRoom.furniturePrice || 0) - (oldRoom.furniturePrice || 0),
          (newRoom.roomTotal || 0) - (oldRoom.roomTotal || 0),
        ];

        summaryRows.push(
          <Fragment>
            <tr className="strikeout" key={oldRoom.name}>
              <td>{oldRoom.roomType}</td>
              <td>{oldRoom.name}</td>
              <td>
                {oldRoom.wwTotal.toLocaleString('en-IN')}
                {' '}
                <FormatNumber number={wwDiff} />
              </td>
              <td>
                {oldRoom.accTotal.toLocaleString('en-IN')}
                {' '}
                <FormatNumber number={accDiff} />
              </td>
              <td>
                {oldRoom.appTotal.toLocaleString('en-IN')}
                {' '}
                <FormatNumber number={appDiff} />
              </td>
              <td>
                {oldRoom.hdsTotal.toLocaleString('en-IN')}
                {' '}
                <FormatNumber number={hdsDiff} />
              </td>
              <td>
                {oldRoom.furniturePrice.toLocaleString('en-IN')}
                {' '}
                <FormatNumber number={furnitureDiff} />
              </td>
              <td>
                {oldRoom.roomTotal.toLocaleString('en-IN')}
                {' '}
                <FormatNumber number={roomTotalDiff} />
              </td>
            </tr>
          </Fragment>,
        );
      }
    });

    // push subtotal row

    summaryRows.push(
      <Fragment>
        <tr>
          <th>Sub Total (₹)</th>
          <td />
          <td>
            {subtotalMap.woodwork.toLocaleString('en-IN')}
            {' '}
            <FormatNumber number={subtotalMap.woodworkDiff} />
          </td>
          <td>
            {subtotalMap.accessories.toLocaleString('en-IN')}
            {' '}
            <FormatNumber number={subtotalMap.accessoriesDiff} />
          </td>
          <td>
            {subtotalMap.appliances.toLocaleString('en-IN')}
            {' '}
            <FormatNumber number={subtotalMap.appliancesDiff} />
          </td>
          <td>
            {subtotalMap.services.toLocaleString('en-IN')}
            {' '}
            <FormatNumber number={subtotalMap.servicesDiff} />
          </td>
          <td>
            {subtotalMap.furniture.toLocaleString('en-IN')}
            {' '}
            <FormatNumber number={subtotalMap.furnitureDiff} />
          </td>
          <td>
            {subtotalMap.roomsTotal.toLocaleString('en-IN')}
            {' '}
            <FormatNumber number={subtotalMap.roomsTotalDiff} />
          </td>
        </tr>
        {newDiscount !== 0 && oldDiscount !== 0 ? (
          <tr>
            <td />
            <td />
            <td />
            <td />
            <td />
            <td />
            <th>Discount (₹)</th>
            <td>
              {newDiscount}
              {' '}
              <FormatNumber number={newDiscount - oldDiscount} />
            </td>
          </tr>
        ) : null}
        <tr>
          <td />
          <td />
          <td />
          <td />
          <td />
          <td />
          <th>Total (₹)</th>
          <td>
            {(subtotalMap.roomsTotal - newDiscount).toLocaleString('en-IN')}
            {' '}
            <FormatNumber number={subtotalMap.roomsTotalDiff} />
          </td>
        </tr>
      </Fragment>,
    );

    return summaryRows;
  }

  render() {
    const { summaryData } = this.props;

    return (
      <Container>
        <h1>Summary</h1>
        <br />
        <Table>
          <thead>
            <tr>
              <th>Room Type</th>
              <th>Room Name</th>
              <th>Woodwork (₹)</th>
              <th>Accessories (₹)</th>
              <th>Appliances (₹)</th>
              <th>Services (₹)</th>
              <th>Furniture (₹)</th>
              <th>Total (₹)</th>
            </tr>
          </thead>
          <tbody>{this.generateSummaryRows(summaryData)}</tbody>
        </Table>
      </Container>
    );
  }
}

// ComparisionTable.propTypes = {
//   summaryData: PropTypes.object,
// };

export default ComparisionTable;



// WEBPACK FOOTER //
// ./src/components/ComparisionSummary/index.js